// extracted by mini-css-extract-plugin
export default {"guidelineOverview":"GuidelineOverview_guidelineOverview__uOJJn","leftPanel":"GuidelineOverview_leftPanel__QjtLm","rightPanel":"GuidelineOverview_rightPanel__FFw-F"};